// import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";

// const Header = () => {
//   return (
//     <>
//       <div className="header  bg-gradient-default opacity-8  pb-5 mb-5 ">
//         {/* 임시로 막아두기 */}
//         <Container fluid className="mb-3 p-0 w-100">
//           {/* <div className="header-body">
//             <Row>
//               <Col lg="6" xl="4">
//                 <Card className="card-stats mb-4 mb-xl-0">
//                   <CardBody>
//                     <Row>
//                       <div className="col">
//                         <CardTitle
//                           tag="h3"
//                           className="text-uppercase mb-3"
//                         >
//                           총 문의자 수
//                         </CardTitle>
//                         <span className="h2 font-weight-bold mb-0">
//                           350,897
//                         </span>
//                       </div>
//                       <Col className="col-auto">
//                         <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
//                           <i className="fas fa-chart-bar" />
//                         </div>
//                       </Col>
//                     </Row>
//                     <p className="mt-3 mb-0 text-muted text-sm">

//                     </p>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col lg="6" xl="4">
//                 <Card className="card-stats mb-4 mb-xl-0">
//                   <CardBody>
//                     <Row>
//                       <div className="col">
//                         <CardTitle
//                           tag="h3"
//                           className="text-uppercase mb-3"
//                         >
//                           오늘 새로운 문의
//                         </CardTitle>
//                         <span className="h2 font-weight-bold mb-0">2,356</span>
//                       </div>
//                       <Col className="col-auto">
//                         <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
//                           <i className="fas fa-chart-pie" />
//                         </div>
//                       </Col>
//                     </Row>
//                     <p className="mt-3 mb-0 text-muted text-sm">

//                     </p>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col lg="6" xl="4">
//                 <Card className="card-stats mb-4 mb-xl-0">
//                   <CardBody>
//                     <Row>
//                       <div className="col">
//                         <CardTitle
//                           tag="h"
//                           className="text-uppercase mb-3"
//                         >
//                           답변 대기
//                         </CardTitle>
//                         <span className="h2 font-weight-bold mb-0">924</span>
//                       </div>
//                       <Col className="col-auto">
//                         <div className="icon icon-shape bg-yellow text-white rounded-circle shadow">
//                           <i className="fas fa-users" />
//                         </div>
//                       </Col>
//                     </Row>
//                     <p className="mt-3 mb-0 text-muted text-sm">

//                     </p>
//                   </CardBody>
//                 </Card>
//               </Col>
//             </Row>
//           </div> */}
//           <div className="flex justify-content-end text-right col pt-4 " style={{ justifyItems: 'end' }}>
//             <div style={{ maxWidth: '1200px' }}>
//               <span className=" rounded-circle bg-white" style={{ padding: '10px' }} >
//                 <svg className="my-2 " width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg"
//                   style={{ cursor: 'pointer', outline: 'none' }}
//                   tabIndex="0"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     window.alert('::::::::::::::::::::');
//                     // navigate('/admin/notification');
//                   }}>
//                   <circle cx="23.5" cy="2.5" r="2.5" fill="#EC3939" />
//                   <path d="M22.739 18.5323C22.074 17.4292 21.0856 14.3079 21.0856 10.2312C21.0856 7.78291 20.0757 5.43493 18.2782 3.70375C16.4807 1.97257 14.0427 1 11.5006 1C8.9585 1 6.52052 1.97257 4.72299 3.70375C2.92545 5.43493 1.91561 7.78291 1.91561 10.2312C1.91561 14.309 0.925959 17.4292 0.261 18.5323C0.0911909 18.8127 0.00116852 19.1314 1.12995e-05 19.456C-0.00114593 19.7806 0.0866032 20.0998 0.254409 20.3814C0.422215 20.663 0.664144 20.8969 0.955799 21.0597C1.24745 21.2225 1.57852 21.3083 1.91561 21.3086H6.80515C7.02629 22.3507 7.61439 23.2873 8.46998 23.96C9.32558 24.6326 10.3961 25 11.5006 25C12.6051 25 13.6756 24.6326 14.5312 23.96C15.3868 23.2873 15.9749 22.3507 16.196 21.3086H21.0856C21.4226 21.3081 21.7535 21.2221 22.045 21.0593C22.3365 20.8964 22.5782 20.6624 22.7459 20.3809C22.9136 20.0994 23.0012 19.7803 23 19.4557C22.9988 19.1312 22.9088 18.8127 22.739 18.5323ZM11.5006 23.1548C10.9061 23.1546 10.3263 22.977 9.84096 22.6464C9.35561 22.3157 8.9886 21.8484 8.79044 21.3086H14.2108C14.0126 21.8484 13.6456 22.3157 13.1602 22.6464C12.6749 22.977 12.0951 23.1546 11.5006 23.1548ZM1.91561 19.4623C2.83816 17.9346 3.83261 14.3944 3.83261 10.2312C3.83261 8.27256 4.64048 6.39417 6.07851 5.00923C7.51654 3.62429 9.46692 2.84623 11.5006 2.84623C13.5343 2.84623 15.4847 3.62429 16.9227 5.00923C18.3607 6.39417 19.1686 8.27256 19.1686 10.2312C19.1686 14.391 20.1606 17.9311 21.0856 19.4623H1.91561Z" fill="black" />
//                 </svg>
//                 {/* <svg className="mt-2" width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
//                 <path d="M22.739 18.5323C22.074 17.4292 21.0856 14.3079 21.0856 10.2312C21.0856 7.78291 20.0757 5.43493 18.2782 3.70375C16.4807 1.97257 14.0427 1 11.5006 1C8.9585 1 6.52052 1.97257 4.72299 3.70375C2.92545 5.43493 1.91561 7.78291 1.91561 10.2312C1.91561 14.309 0.925959 17.4292 0.261 18.5323C0.0911909 18.8127 0.00116852 19.1314 1.12995e-05 19.456C-0.00114593 19.7806 0.0866032 20.0998 0.254409 20.3814C0.422215 20.663 0.664144 20.8969 0.955799 21.0597C1.24745 21.2225 1.57852 21.3083 1.91561 21.3086H6.80515C7.02629 22.3507 7.61439 23.2873 8.46998 23.96C9.32558 24.6326 10.3961 25 11.5006 25C12.6051 25 13.6756 24.6326 14.5312 23.96C15.3868 23.2873 15.9749 22.3507 16.196 21.3086H21.0856C21.4226 21.3081 21.7535 21.2221 22.045 21.0593C22.3365 20.8964 22.5782 20.6624 22.7459 20.3809C22.9136 20.0994 23.0012 19.7803 23 19.4557C22.9988 19.1312 22.9088 18.8127 22.739 18.5323ZM11.5006 23.1548C10.9061 23.1546 10.3263 22.977 9.84096 22.6464C9.35561 22.3157 8.9886 21.8484 8.79044 21.3086H14.2108C14.0126 21.8484 13.6456 22.3157 13.1602 22.6464C12.6749 22.977 12.0951 23.1546 11.5006 23.1548ZM1.91561 19.4623C2.83816 17.9346 3.83261 14.3944 3.83261 10.2312C3.83261 8.27256 4.64048 6.39417 6.07851 5.00923C7.51654 3.62429 9.46692 2.84623 11.5006 2.84623C13.5343 2.84623 15.4847 3.62429 16.9227 5.00923C18.3607 6.39417 19.1686 8.27256 19.1686 10.2312C19.1686 14.391 20.1606 17.9311 21.0856 19.4623H1.91561Z" fill="black" />
//               </svg> */}
//               </span>

//             </div>
//           </div>
//         </Container>
//       </div>
//     </>
//   );
// };

// export default Header;

/*!

=========================================================
* Argon Dashboard React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";

const Header = () => {
  return (
    <>
      <div className="header bg-gradient-default opacity-8 pb-4 pt-5 pt-md-8">
        {/* <Container fluid>
          <div className="header-body">
            <Row>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Traffic
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          350,897
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                          <i className="fas fa-chart-bar" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-success mr-2">
                        <i className="fa fa-arrow-up" /> 3.48%
                      </span>{" "}
                      <span className="text-nowrap">Since last month</span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          New users
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">2,356</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                          <i className="fas fa-chart-pie" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-danger mr-2">
                        <i className="fas fa-arrow-down" /> 3.48%
                      </span>{" "}
                      <span className="text-nowrap">Since last week</span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Sales
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">924</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-yellow text-white rounded-circle shadow">
                          <i className="fas fa-users" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-warning mr-2">
                        <i className="fas fa-arrow-down" /> 1.10%
                      </span>{" "}
                      <span className="text-nowrap">Since yesterday</span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Performance
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">49,65%</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                          <i className="fas fa-percent" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-success mr-2">
                        <i className="fas fa-arrow-up" /> 12%
                      </span>{" "}
                      <span className="text-nowrap">Since last month</span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container> */}
      </div>
    </>
  );
};

export default Header;
